(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('AttendanceRulesController', AttendanceRulesController);

  AttendanceRulesController.$inject = ['$rootScope', 'CompanyService', 'NotificationFactory', 'AutomaticDistributionService', 'StatusService', 'NotificationService'];

  function AttendanceRulesController ($rootScope, CompanyService, NotificationFactory, AutomaticDistributionService, StatusService, NotificationService) {
    var vm = this;
    vm.clickSave = false;
    vm.save = save;
    vm.changeRemoveAttendance = changeRemoveAttendance;
    vm.changeTimeWaitingClient = changeTimeWaitingClient;
    vm.company_id = $rootScope.user_data.company_id;
    vm.metadata = angular.copy($rootScope.company_metadata);

    StatusService.all()
      .$promise
      .then(function (data) {
        vm.statuses = data;
      })
      .catch(function (data) {
        NotificationService.errorHandler(data, $rootScope.labels.errorLoadStatus)
      });

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vm.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, 'Erro ao carregar configurações');
      });

    AutomaticDistributionService
      .find()
      .$promise
      .then(function (data) {
        vm.auto_dist = data;
      }).catch(function (data) {
        NotificationService.errorHandler(data, 'Erro ao buscar configurações da distribuição.')
      });

    function changeRemoveAttendance () {
      if (vm.metadata.attendances.remove_chats_logout && !vm.metadata.attendances.hasOwnProperty('remove_chats_logout_rule')) {
        vm.metadata.attendances['remove_chats_logout_rule'] = 1
      }
    }

    function changeTimeWaitingClient () {
      if ((vm.metadata.attendances.time_waiting_client_to_busy_client > 0 &&
                !vm.metadata.attendances.hasOwnProperty('change_status_when_busy_client')) ||
                (vm.metadata.attendances.hasOwnProperty('change_status_when_busy_client') && vm.metadata.attendances.change_status_when_busy_client == null)) {
        vm.metadata.attendances['change_status_when_busy_client'] = '0'
        vm.metadata.attendances['status_busy_client'] = null
      } else if (!vm.metadata.attendances.time_waiting_client_to_busy_client &&
                vm.metadata.attendances.change_status_when_busy_client == '1') {
        vm.metadata.attendances['change_status_when_busy_client'] = '0'
      }
    }

    function save () {
      vm.clickSave = true;
      AutomaticDistributionService
        .find()
        .$promise
        .then(function (data) {
          vm.auto_dist = data;
          if (!vm.metadata.hasOwnProperty('attendances')) {
            NotificationService.warningHandler(null, 'Nenhuma regra foi configurada.');
            return false;
          }
          if (vm.metadata.attendances.hasOwnProperty('time_waiting_client_to_busy_client') &&
                        vm.metadata.attendances.time_waiting_client_to_busy_client != null &&
                        vm.metadata.attendances.time_waiting_client_to_busy_client <= 0) {
            NotificationService.warningHandler(null, 'Informe o tempo em minutos maior que zero.');
            return false;
          }
          if (vm.metadata.attendances.hasOwnProperty('change_status_when_busy_client') &&
                        vm.metadata.attendances.change_status_when_busy_client === '1' &&
                        (!vm.metadata.attendances.status_busy_client || vm.metadata.attendances.status_busy_client === '')) {
            NotificationService.warningHandler(null, 'Selecione o status de classificação em que o atendimento será direcionado.');
            return false;
          }
          if (vm.auto_dist.allow_if_client_not_respond && !vm.metadata.attendances.time_waiting_client_to_busy_client) {
            NotificationService.warningHandler(null, "A classificação de 'cliente não responde' está sendo utilizada na configuração da distribuição automática.");
            return false;
          }

          if (vm.metadata.attendances) {
            CompanyService
              .saveMetadata({ id: vm.company_id }, vm.metadata)
              .$promise
              .then(function (data) {
                vm.clickSave = false;
                CompanyService.saveAttendanceRules({ company_id: vm.company_id }, vm.metadata.attendances);
                $rootScope.company_metadata = angular.copy(vm.metadata);
                NotificationService.successHandler(data, 'Regras atualizadas com sucesso!');
              })
              .catch(function (error) {
                NotificationService.errorHandler(error, 'Não foi possível salvar as regras.');
              });
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao buscar configurações da distribuição.')
        });
    }
  }
})();
